module.exports = __webpack_public_path__ + "static/media/backWave23.fac65df8.svg";